export default __webpack_public_path__ + "static/inaction-7a072a750c4b6c64a89c9069ec04089e.png";